<template>
  <div class="list">
    <div class="choose-state">
      <div
        v-for="(data,index) in chooses"
        :key="data.Vid"
        class="tab_item"
        @click="active(index,data.VideoCategoryName)"
        :class="choose == index?'choose':''"
      >{{data.VideoCategoryName | times}}</div>
    </div>

    <!-- 内容 -->
    <div class="content">
      <div
        class="list-template"
        v-for="(data,index) in datas"
        :key="index"
        @click="goVedio(data)"
      >
        <img :src="data.VideoImage | filterB" alt />
        <p class="h-line-2">{{ handleText(data.VideoTitle) }}</p>
        <!-- <p>{{data.times}}</p> -->
      </div>
    </div>
    <div class="next-url" @click="loadMore">---- 加载更多----</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chooses: [],
      choose: 0,
      datas: [],
      pager: 1,
      name:''
    };
  },
  methods: {
    handleText(text) {
      return text.indexOf('【本土课件】') > -1 ? text.split('【本土课件】').join('') : text
    },
    active(index, name) {
      this.choose = index;
      this.name = name;
      this.datas=[];
      this.getMsg(name);
    },
    getChoose() {
      this.axios
        .get(`/api/Courseware/VideoTitle?title=${this.$route.query.title}`)
        .then(e => {
          // console.log(e.data);
          if (e.data.code == 0) {
            this.chooses = e.data.msg;
            this.getMsg(this.chooses[0].VideoCategoryName.split("（")[0]);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getMsg(msg) {
      this.axios
        .get(
          `/api/Courseware/VideoList?title=${this.$route.query.title}&name=${msg}&pager=${this.pager}`
        )
        .then(e => {
          // console.log(e.data);
          if (e.data.code == 0) {
            e.data.msg.filter(item => {
              this.datas.push(item);
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
     goVedio(sourceLink) {           
      this.$router.push({
        path: "/boutique/videoPlayer",
        query: { title: "视频播放", source: JSON.stringify(sourceLink) }
      });
    },
    loadMore() {
      this.pager++;
      this.getMsg(this.name)
    },
  },
  mounted: function() {
    this.getChoose();
  },
  filters: {
    filterB: function(value) {
      if (value) {
        value = value.split("?")[0];
        return value.indexOf("http") > -1
          ? value
          : `http://qswgadmin.djplus.cn/Tittle/${value}`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  .next-url {
    background: #fff;
    font-size: 0.3rem;
    text-align: center;
    line-height: 3;
  }
  .content {
    .list-template {
      &:nth-child(even) {
        margin-left: 2%;
      }
      p {
        &:nth-child(3) {
          color: #999999;
        }
        padding: 0 0.1rem;
      }
      img {
        width: 100%;
        height: 3rem;
      }
      width: 49%;
      background: #fff;
      margin-top: 0.2rem;
      padding-bottom: 0.2rem;
    }
    width: 94%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
  .choose-state {
    overflow-x: scroll;
    width: 100%;
    white-space: nowrap;
    background: #fff;
    display: -webkit-box;
    padding: 0.1rem 0;
    box-sizing: border-box;
    .tab_item {
      color: #999999;
      margin-left: 0.4rem;
      max-width: 18em;
      white-space: normal;
    }
  }
  .choose {
    color: #f9ba4e !important;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>